import { PROJECTS_FETCH,PROJECTS_FETCH_SUCCESS, PROJECTS_FETCH_ERROR,
PROJECTS_SELECT_PROJECT,PROJECTS_SELECT_FUNCTION,PROJECTS_SELECT_GBU,PROJECT_EDIT_FUNCTIONS,
PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS,PROJECTS_ADD_SUCCESS,PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS,PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS,
PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS,
PROJECTS_EDIT_MANAGER_OF_FUNCTIONS,
PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS,
PROJECTS_DELETE_IWPP_APPROVER_SUCCESS,
PROJECTS_DELETE_IWPP_APPROVER,
PROJECTS_FETCH_IWPP_APPROVERS,
PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS,
PROJECTS_FETCH_IWPP_APPROVERS_ERROR,
PROJECT_FUNCTION_FETCH_DETAILS_ERROR,
PROCEDURE_ADD_TO_WORKFLOW_SUCCESS,
PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR,
PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS,
PROJECT_FUNCTION_FETCH_DETAILS,
PROJECTS_UPDATE_PROJECT,
PROJECTS_UPDATE_PROJECT_SUCCESS,
PROJECTS_UPDATE_PROJECT_ERROR,
} from "../reduxActions/Types";

import _ from 'lodash';

const INITIAL_STATE = {
  
  fetchingProjets: false,
  gbus: null,
  projectsFetchError: false,
  functions:null,
  selectedProjectOrGbu : null,
  selectedFunction : null,
  selectedFunctionDetails : null,
  editingProjectFunctions : false,
  updatingProjectDetails : false,
  projects: null,
};


const computeInitialProjectFunctionsFormValues = ({allFunctions,projectFunctions}) => {
   return allFunctions.map( aFunction => {
      const isChecked = !!(_.find(projectFunctions, {'id':aFunction.id}));
      return {...aFunction,isChecked}
   } )
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROJECTS_ADD_SUCCESS : {

      const gbuIndex = state.gbus.findIndex(gbu => gbu.id === action.payload.gbuId);

      let updatedProjects = [...state.gbus[gbuIndex].projects];
      updatedProjects.push(action.payload);
      updatedProjects = _.sortBy(updatedProjects,'name');
      const updatedState = {...state};
      updatedState.gbus[gbuIndex].projects = updatedProjects;
      return updatedState;
    }
    case PROJECT_FUNCTION_FETCH_DETAILS :
    case PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS : {
      return {
        ...state,
        updatingProjectDetails:true
      };
    }
    case PROJECT_FUNCTION_FETCH_DETAILS_ERROR:
    case PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_ERROR:
      return {
        ...state,
        updatingProjectDetails:false
      };
    case PROJECTS_UPDATE_GBU_WORKFLOW_APPROVERS_SUCCESS :
    case PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS :
    case PROJECT_FUNCTION_FETCH_DETAILS_SUCCESS : {
      const updatedState = {
        ...state,
        selectedFunctionDetails: action.payload,
        updatingProjectDetails:false
      };

      if (
        action.type === PROJECTS_UPDATE_PROJECT_WORKFLOW_APPROVERS_SUCCESS &&
        state.selectedProjectOrGbu &&
        !state.selectedProjectOrGbu.isGbu &&
        state.selectedFunction &&
        state.selectedFunction.id
      ) {
        const markAssigned = (items = []) =>
          items.map((fn) =>
            fn && fn.id === state.selectedFunction.id
              ? { ...fn, isChecked: true, isAssigned: true }
              : fn
          );

        const updatedProjectOrGbu = {
          ...state.selectedProjectOrGbu,
          functions: markAssigned(state.selectedProjectOrGbu.functions),
          initialFunctionFormValues: markAssigned(state.selectedProjectOrGbu.initialFunctionFormValues),
        };

        updatedState.selectedProjectOrGbu = updatedProjectOrGbu;
      }

      return updatedState;
    }

    case PROJECTS_EDIT_MANAGER_OF_FUNCTIONS : {
      const {mofBun,mofpBun,mofid,mofpid,mofDisplayName,mofpDisplayName} = state.selectedProjectOrGbu;
      const primary = mofid ? {bun:mofBun, displayName:mofDisplayName} : null;
      const proxy = mofpid ? {bun:mofpBun, displayName:mofpDisplayName} : null;
      const workflowSteps = [{
        stepLabel : "IWPP",
        primary,
        proxy,
          
      }];

      const selectedFunctionDetails = {id:0,name:"Manager of Functions",workflowSteps};
      return {
        ...state,
        selectedFunctionDetails,
        selectedFunction:selectedFunctionDetails
      };
    }
    /* Not Sure why this was here. Remove once determined it's not necessary
    case PROCEDURE_ADD_TO_WORKFLOW_SUCCESS : {
      return {
        ...state,
        selectedFunctionDetails:null,
        selectedFunction:null
      };
    }
    */
    case PROJECT_EDIT_FUNCTIONS : {
      return {
        ...state,
        editingProjectFunctions: action.payload
      };
    }
    case PROJECTS_SELECT_FUNCTION : {
      return {
        ...state,
        selectedFunction: action.payload
      };
    }
    case PROJECT_EDIT_FUNCTIONS_SAVE_SUCCESS : {
      const { updatedFunctions } = action.payload;
      const initialFunctionFormValues = computeInitialProjectFunctionsFormValues({ allFunctions: state.functions, projectFunctions: updatedFunctions });

      const currentSelectedFunction = state.selectedFunction;
      const stillHasSelectedFunction = currentSelectedFunction
        ? _.some(updatedFunctions, { id: currentSelectedFunction.id })
        : false;

      const preservedSelectedFunction = stillHasSelectedFunction ? currentSelectedFunction : null;
      const preservedSelectedFunctionDetails = stillHasSelectedFunction ? state.selectedFunctionDetails : null;

      return {
        ...state,
        editingProjectFunctions: false,
        selectedProjectOrGbu: {
          ...state.selectedProjectOrGbu,
          initialFunctionFormValues,
          functions: updatedFunctions,
        },
        selectedFunction: preservedSelectedFunction,
        selectedFunctionDetails: preservedSelectedFunctionDetails,
      };
    }
    case PROJECTS_SELECT_PROJECT : {
      const initialFunctionFormValues = computeInitialProjectFunctionsFormValues({allFunctions:state.functions,projectFunctions:action.payload.functions});
      return {
        ...state,
        editingProjectFunctions:false,
        selectedProjectOrGbu: {...action.payload,isGbu:false,initialFunctionFormValues},
        selectedFunction:null,
        selectedFunctionDetails : null
      };
    }
    case PROJECTS_SELECT_GBU : {
      return {
        ...state,
        editingProjectFunctions:false,
        selectedProjectOrGbu: {...action.payload,isGbu:true},
        selectedFunction:null,
        selectedFunctionDetails : null
      };
    }
    case PROJECTS_FETCH:
    return {
      ...state,
      fetchingProjets: true,
      projectsFetchError: false
    };

    case PROJECTS_FETCH_IWPP_APPROVERS : {
      
      const selectedProjectOrGbu = {...state.selectedProjectOrGbu,}
      selectedProjectOrGbu.approversFormValues = [];
      return {...state,selectedProjectOrGbu};
    }
    case PROJECTS_DELETE_IWPP_APPROVER_SUCCESS :
    case PROJECTS_UPDATE_IWPP_APPROVERS_SUCCESS : 
    case PROJECTS_FETCH_IWPP_APPROVERS_SUCCESS : {
      const selectedProjectOrGbu = {...state.selectedProjectOrGbu,}
      selectedProjectOrGbu.approversFormValues = action.payload.map(approver => ({
          ...approver,
          proxy : approver.proxyUserBun ?  {bun:approver.proxyUserBun,displayName:approver.proxyUserDisplayName} : null,
          primary : approver.primaryUserBun ?  {bun:approver.primaryUserBun,displayName:approver.primaryUserDisplayName} : null,
      }
      ))
      return {...state,selectedProjectOrGbu};
    }
    case PROJECTS_FETCH_SUCCESS:
      const {gbus,functions} = action.payload

      for (let gbu of gbus)
      {
        let functions  = [];

        for (let project of gbu.projects) {

          functions = [...functions,...project.functions];

        }

        functions = _.uniqBy(functions,'id');
        functions = _.sortBy(functions, aFunction => aFunction.name.toUpperCase() );

        gbu.functions = functions;

      }

      return {
        ...state,
       gbus,
       functions,
       fetchingProjets:false
      };
    case PROJECTS_FETCH_ERROR:
      return {
        ...state,
       fetchingProjets:false,
       projectsFetchError:true
      };
    case PROJECTS_UPDATE_PROJECT : {
      return {
        ...state,
      };
    }
    case PROJECTS_UPDATE_PROJECT_SUCCESS : {
      const initialFunctionFormValues = computeInitialProjectFunctionsFormValues({allFunctions:state.functions,projectFunctions:action.payload.project.functions});
      let projects  = [];
      let gbus = []; 
        for(let key in action.payload.gbus){  
            if(action.payload.gbus.hasOwnProperty(key)){  
                gbus.push(action.payload.gbus[key]);  
            }  
        }  

        if (gbus && gbus.length > 0) {
            for (let gbu of gbus) {
                for (let project of gbu.projects) {
                    projects.push(project);
                };
            };
      }

      return {
        ...state,
        selectedProjectOrGbu: {...action.payload.project,isGbu:false,initialFunctionFormValues},
        projects: projects,
        gbus: gbus,
      };

    }

    case 'RESET_ALL_REDUX_STATE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
